import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const RadarSonar = () => {
  const { map, coordinates, radius, isSearching } = useSelector((state) => state.radar);
  const [pixel, setPixel] = useState({ x: 0, y: 0 });
  const [pixelRadius, setPixelRadius] = useState(100);

  const updateRadarPosition = () => {
    if (!map) return;

    const center = map.current.project(coordinates);
    const offset = map.current.project([
      coordinates[0],
      coordinates[1] + (radius / 111320),
    ]);
    const pixelRadius = Math.abs(center.y - offset.y);

    setPixel({ x: center.x, y: center.y });
    setPixelRadius(pixelRadius);
  };

  useEffect(() => {
    if (!map) return;

    updateRadarPosition();

    map.current.on('move', updateRadarPosition);
    map.current.on('zoom', updateRadarPosition);

    return () => {
      map.current.off('move', updateRadarPosition);
      map.current.off('zoom', updateRadarPosition);
    };
  }, [map, coordinates, radius]);
  
  return (
    <div
      className={`absolute pointer-events-none z-20 transition-opacity duration-1000 ${isSearching ? 'opacity-100' : 'opacity-0'}`}
      style={{
        left: `${pixel.x}px`,
        top: `${pixel.y}px`,
        width: `${pixelRadius * 2}px`,
        height: `${pixelRadius * 2}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className='relative w-full h-full rounded-full overflow-hidden'>
        {/* Point central */}
        <div className='absolute w-1 h-1 bg-ih-blue rounded-full left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2' />

        {/* Ligne verticale */}
        <div className='absolute left-1/2 top-0 h-full w-px bg-ih-blue opacity-20 -translate-x-1/2' />

        {/* Ligne horizontale */}
        <div className='absolute top-1/2 left-0 w-full h-px bg-ih-blue opacity-20 -translate-y-1/2' />

        {/* Cercles de mesure */}
        <div className='absolute inset-0 rounded-full border border-ih-blue opacity-60' />
        <div className='absolute inset-[10%] rounded-full border border-ih-blue opacity-60' />
        <div className='absolute inset-[20%] rounded-full border border-ih-blue opacity-60' />
        <div className='absolute inset-[30%] rounded-full border border-ih-blue opacity-60' />
        <div className='absolute inset-[46%] rounded-full border border-ih-blue opacity-60' />
        {/* Balayage rotatif */}
        <div className='absolute w-full h-full animate-spin'>
          <div className='w-full h-full bg-gradient-to-tr from-ih-blue to-transparent origin-left rounded-full opacity-20' />
        </div>

        {/* Ondes */}
        {Array.from({ length: 3 }).map((_, i) => (
          <span
            key={i}
            className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 rounded-full border border-ih-blue/70 pointer-events-none animate-ripple'
            style={{
              animationDelay: `${i * 1.2}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default RadarSonar;
